import { AssignedScreenersScreen } from '@/components/AssignedScreenersScreen';

export default function AssignedScreeners() {
  return <AssignedScreenersScreen />;
}
